import React, { useEffect } from 'react';
import {
  Box,
  Paper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CarouselComponent from '../../common/components/CarouselComponent';
import ProfileSetUpForm from './ProfileSetUpForm';
import { getMeUser } from '../../api/authApi';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, signUpSuccess } from '../../features/authSlice';
import LoadingSpinner from '../../common/components/LoadingSpinner';
import { showNotification } from '../../common/components/Notification/ToastifyNotification';

const ProfileSetUp = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getUser = async () => {
    try {
      const response = await getMeUser();
      if (response.data?.user_id) {
        dispatch(signUpSuccess({
          user: response.data
        }));
        dispatch(setLoading({
          loading: false
        }));
      }
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      dispatch(setLoading({
        loading: false
      }));
      showNotification(errorMessage, 'error');
    }
  }

  useEffect(() => {
    dispatch(setLoading({
      loading: true
    }));
    getUser();
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {loading && (
        <LoadingSpinner />
      )}
      <Paper
        elevation={isMobile ? 0 : 3}
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: 0,
          overflow: 'hidden',
        }}
      >

        <Box sx={{ display: 'flex', minHeight: '100vh', overflow: 'hidden' }}>
          {/* Left Side - Carousel */}
          <Box
            sx={{
              width: '54%',
              display: { xs: 'none', md: 'block' },
              flexShrink: 0,
            }}
          >
            <CarouselComponent />
          </Box>

          {/* Right Side - Form */}
          <Box
            sx={{
              height: '100vh',
              width: '500px',
              margin: '0 auto',
              overflowY: 'auto',
              pt: { lg: 3 }
            }}
          >
            <ProfileSetUpForm />
          </Box>
        </Box>

        {isMobile && (
          <Box sx={{ height: '100%', overflowY: 'auto' }}>
            <ProfileSetUpForm />
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ProfileSetUp;